import HTTP from "@/_helpers/http";
import { ADMINNOTIFICATION__API } from "@/_helpers/urls";
import { ADMINNOTIFICATION__MUTATIONS } from "../mutation-types";
import { ADMINNOTIFICATION__ACTIONS } from "../action-types";

// State
const state = {
  notifications: [],
  pollingInterval: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [ADMINNOTIFICATION__MUTATIONS.ADMINGETNOTIFICATION](state, data) {
    let shouldRing = false;
    const previousNotifications = Array.isArray(state.notifications) ? state.notifications : [];

    data.forEach((newItem) => {
      const oldItem = previousNotifications.find(
        (n) => n.type === newItem.type
      );

      if (oldItem && newItem.count > oldItem.count) {
        shouldRing = true;
      }
    });

    if (shouldRing) {
      const audio = document.getElementById("notification-bell");
      if (audio) {
        audio.currentTime = 0;
        audio.play();
      }
    }
    state.notifications = data;
  },

  [ADMINNOTIFICATION__MUTATIONS.SET_POLLING_INTERVAL](state, interval) {
    state.pollingInterval = interval;
  },
};

// Actions
const actions = {
  async [ADMINNOTIFICATION__ACTIONS.ADMINGETNOTIFICATION]({ commit, state }) {
    try {
      const response = await HTTP().get(
        ADMINNOTIFICATION__API.ADMINGETNOTIFICATION
      );
      commit(ADMINNOTIFICATION__MUTATIONS.ADMINGETNOTIFICATION, response.data);
      //console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINNOTIFICATION__ACTIONS.ADMINMARKASREADNOTIFICATION]({ dispatch }) {
    try {
      await HTTP().post(ADMINNOTIFICATION__API.ADMINMARKASREADNOTIFICATION);
      await dispatch(ADMINNOTIFICATION__MUTATIONS.ADMINGETNOTIFICATION);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINNOTIFICATION__ACTIONS.ADDCLIENTNOTIFICATION]({ commit }) {
    try {
      await HTTP().post(ADMINNOTIFICATION__API.ADDCLIENTNOTIFICATION);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINNOTIFICATION__ACTIONS.ADMINUPDATENOTIFICATION](
    { dispatch },
    data
  ) {
    try {
      await HTTP().patch(ADMINNOTIFICATION__API.ADMINUPDATENOTIFICATION, data);
      await dispatch(ADMINNOTIFICATION__MUTATIONS.ADMINGETNOTIFICATION);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINNOTIFICATION__ACTIONS.SET_POLLING_INTERVAL]({
    dispatch,
    commit,
  }) {
    await dispatch(ADMINNOTIFICATION__ACTIONS.ADMINGETNOTIFICATION);

    const interval = setInterval(() => {
      dispatch(ADMINNOTIFICATION__ACTIONS.ADMINGETNOTIFICATION);
    }, 15000);

    commit(ADMINNOTIFICATION__MUTATIONS.SET_POLLING_INTERVAL, interval);
  },
  async [ADMINNOTIFICATION__ACTIONS.STOP_POLLING_INTERVAL]({ state, commit }) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval);
      commit(ADMINNOTIFICATION__MUTATIONS.SET_POLLING_INTERVAL, null);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
